var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 1001.5748031496063 1001.514435695538",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l1001.5748 0l0 1001.51447l-1001.5748 0l0 -1001.51447z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l1001.5748 0l0 1001.51447l-1001.5748 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.22039207541994 0.0 0.0 33.22039207541994 0.0 0.0)",
    spreadMethod: "pad",
    x1: -8.416687645199453,
    y1: 15.084178418381637,
    x2: 15.083027866495009,
    y2: 38.56518820318539
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0984e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0984e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5500001,
    stopColor: "#74b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#74b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71000004,
    stopColor: "#81ecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ecec"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.1)",
    d: "m353.37238 785.52496l-199.59627 -231.07355l59.30832 -216.25458l-45.051132 -268.12598l261.75513 269.20474l-49.614655 37.05249l239.51508 0l-47.901733 -37.72705l261.7552 -271.2257l-45.62213 273.11285l59.879272 212.48032l-201.307 231.74805l161.6726 -371.60632l-72.1391 54.165375l-234.95377 466.8635l-235.52252 -465.51706l-72.425735 -56.52231z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b284270754f911c30fd8db1036302c98.svg";
export { ForwardRef as ReactComponent };